import "../sass/main.scss";

// import Vue from 'vue';
// import VueRouter from 'vue-router';

// Vue.use(VueRouter);

// if (document.getElementById('app')) {
//     var router = new VueRouter({
//         // mode: 'history',
//         routes: [
//             { path: '/:category?', component: IsotopeProjects },
//         ]
//     });

// //Init vue if is app id on dom.
//     new Vue({
//         el: '#app',
//         router: router,
//         components: {
//             'isotopeprojects': IsotopeProjects
//         }
//     });
// }


require('./main.js'); 